import useVenueUrl from './useVenueUrl';

const useAgendaUrl = () => useVenueUrl('/agenda');

export default useAgendaUrl;
